function buildHeapSnippet(id: string): string {
  return `if (${id} && !window.heap) {
  (window.heap=window.heap||[]),(heap.load=function(e,t){
    (window.heap.appid=e),(window.heap.config=t=t||{});
    var r=document.createElement("script");
    (r.type="text/javascript"),(r.async=!0),
    (r.src="https://cdn.heapanalytics.com/js/heap-"+e+".js");
    var a=document.getElementsByTagName("script")[0];
    a.parentNode.insertBefore(r,a);
    for(var n=function(e){return function(){heap.push([e].concat(Array.prototype.slice.call(arguments,0)))}},
        p=["addEventProperties","addUserProperties","clearEventProperties","identify",
           "resetIdentity","removeEventProperty","setEventProperties","track","unsetEventProperty"],
        o=0;o<p.length;o++)heap[p[o]]=n(p[o]);
  });
  function sanitizeDomain(domain,path){
    var D={LEGACY_PORTAL:"legacyportal",PORTAL_2:"portal2",OUTLOOK:"outlook",GP_ARENA:"gparena",CANOPY:"canopy",CCTOOLS:"cctools",UNKNOWN:"unknown"};
    if(!domain)return D.UNKNOWN;
    if(domain===D.LEGACY_PORTAL||domain===D.PORTAL_2||domain===D.OUTLOOK||domain===D.GP_ARENA||domain===D.CANOPY||domain===D.CCTOOLS)return domain;
    else if(domain.indexOf("admin")===0&&path&&path.indexOf("/canopy")>=0)return D.CANOPY;
    else if(domain.indexOf("admin")===0)return D.CCTOOLS;
    else if((domain.indexOf("junipersquare")===-1)||(path&&path.indexOf("/portal")===0))return D.LEGACY_PORTAL;
    else if(domain.match(/^app./g)||path.indexOf("/lp/")>=0)return D.PORTAL_2;
    else if(domain.indexOf("outlook")>=0)return D.OUTLOOK;
    else if(domain.indexOf(".junipersquare.")>=0)return D.GP_ARENA;
    else return D.UNKNOWN;
  }
  function sanitizePath(path){
    if(!path)return undefined;
    var s=path;
    if(path.indexOf("?")>=0)s=path.slice(0,path.indexOf("?"))+"?*";
    if(path.indexOf("/i/")>=0)s=s.replace(/\\/i\\/\\w*/g,"/i/*");
    return s;
  }
  function sanitizeHeapProperties(props){
    return Object.assign(props,{path:sanitizePath(props.path),domain:sanitizeDomain(props.domain,props.path),previous_page:sanitizePath(props.previous_page),query:!!props.query?"*":undefined});
  }
  if(window.location.hostname.indexOf("outlook")===-1){
    heap.load(${id},{rewrite:function(props){
      heap.clearEventProperties();
      if(props){
        var pv=!!props.pageview_properties?sanitizeHeapProperties(Object.assign(props.pageview_properties,{domain:window.location.hostname,path:window.location.pathname})):undefined;
        var sess=!!props.session_properties?sanitizeHeapProperties(props.session_properties):undefined;
        return Object.assign(props,{pageview_properties:pv,session_properties:sess});
      }
      return {};
    }});
    if(window.jsqHeapUserId){heap.identify(window.jsqHeapUserId);}else{heap.resetIdentity();}
  }
}`;
}

export function initHeap(heapId: string, heapDataConsentId: string): void {
  if (!heapId) {
    return;
  }
  const script = document.createElement("script");
  script.type = "text/plain";
  if (heapDataConsentId) {
    script.setAttribute("data-consent-id", heapDataConsentId);
  }
  script.textContent = buildHeapSnippet(JSON.stringify(heapId));
  document.head.appendChild(script);
}

declare global {
  interface Window {
    heap?: {
      identify?: (id: string) => void;
      resetIdentity?: () => void;
    };
    jsqHeapUserId?: string;
  }
}

export function identifyHeapUser(id: string): void {
  window.jsqHeapUserId = id;
  window.heap?.identify?.(id);
}

export function resetHeapIdentity(): void {
  delete window.jsqHeapUserId;
  window.heap?.resetIdentity?.();
}
